import { Select } from 'antd';
import { FC } from 'react';

import useStoresForSearch from 'src/hooks/swr/useStoresForSearch';

interface StoreSearchProps {
  selectedStoreId?: string | null;
  onStoreSelect: (storeId: string | null, storeName: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const StoreSearch: FC<StoreSearchProps> = ({
  selectedStoreId,
  onStoreSelect,
  placeholder = '매장을 검색하세요',
  disabled,
}) => {
  const { stores, isValidating } = useStoresForSearch();

  const options =
    stores?.map((store) => ({
      value: store._id,
      label: `${store.storeCode}-${store.storeNickname ?? store.storeName}`,
    })) ?? [];

  const handleChange = (value: string | undefined) => {
    if (!value) {
      onStoreSelect(null, '');
      return;
    }
    const store = stores?.find((store) => store._id === value);
    if (!store) {
      return;
    }
    const storeName = store.storeNickname ?? store.storeName;
    onStoreSelect(store._id, storeName);
  };

  return (
    <Select
      showSearch
      placeholder={placeholder}
      value={selectedStoreId ?? undefined}
      onChange={handleChange}
      loading={isValidating}
      allowClear
      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
      options={options}
      styles={{
        root: {
          width: '100%',
        },
      }}
      disabled={disabled}
    />
  );
};

export default StoreSearch;
